import { render, staticRenderFns } from "./ViewPersonal.vue?vue&type=template&id=667c29e4&scoped=true&"
import script from "./ViewPersonal.vue?vue&type=script&lang=js&"
export * from "./ViewPersonal.vue?vue&type=script&lang=js&"
import style0 from "./ViewPersonal.vue?vue&type=style&index=0&id=667c29e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c29e4",
  null
  
)

export default component.exports